import spaces from './space-instances/spaces-list.json.js';

const SpacesList = [...spaces];

export { SpacesList };
//# sourceMappingURL=spaces-list.js.map
